import React, { PropTypes } from 'react';
import { Checkbox, Divider, ListItem } from 'material-ui';
import moment from 'moment';

const SelectRequests = props => {
  const {
    requests,
    onCheckRequest,
  } = props;
  return (
    <div style={{ marginBottom: '16px' }}>
      Please select the buyers that your rates are intended for.
      {
        requests.map((request) => (
          <div key={request._id}>
            <ListItem
              primaryText={request.from.name}
              secondaryText={`${moment.utc(request.startDate).format('D MMM YY')} -\n${moment.utc(request.endDate).format('D MMM YY')}  `}
              leftCheckbox={<Checkbox
                checked={Boolean(request.checked)}
                onCheck={onCheckRequest(request)}
              />}
            />
            <Divider/>
          </div>
        ))
      }
    </div>
  );
};
SelectRequests.propTypes = {
  requests: PropTypes.array,
  onCheckRequest: PropTypes.func,
};
export default SelectRequests;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/wizards/select-requests.jsx